import type { PositionFeedEntry } from '@chukua/common';
import type { TrackPoint } from '../trips.api';

/**
 * Adds this truck's newest fixes from a stream message to the track. Fixes of other trucks are ignored, and a fix no newer than the
 * last held (a replay after a reconnect) changes nothing, so the same array comes back and nothing redraws.
 */
export function applyLiveFixes(points: TrackPoint[], truckId: string | null, entries: PositionFeedEntry[]): TrackPoint[] {
  if (!truckId) return points;
  const last = points.at(-1);
  const fresh = entries
    .filter((entry) => entry.truckId === truckId && (!last || Date.parse(entry.deviceTime) > Date.parse(last.deviceTime)))
    .sort((a, b) => Date.parse(a.deviceTime) - Date.parse(b.deviceTime));
  if (fresh.length === 0) return points;
  const added = fresh.map((entry): TrackPoint => ({
    id: `live-${entry.deviceTime}`,
    source: entry.source,
    lat: entry.lat,
    lng: entry.lng,
    accuracyM: null,
    speedMps: entry.speedMps,
    headingDeg: entry.headingDeg,
    deviceTime: entry.deviceTime,
    serverTime: entry.deviceTime,
  }));
  return [...points, ...added];
}
